import { takeEvery, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { updateOrg, errorOrg, ORG_POST } from 'actions/create-org'
import { getConfigJson, getMeta, updateUserData } from 'actions/general'
import { isProduction } from 'util/environment'
import { logInteraction } from 'util/log-interaction'

function _postOrg({ create }, logError) {
  return function*(action) {
    try {
      logInteraction('createOrg')

      const accountEndpoint = '/activate-with'
      const values = action.payload.values
      values.ignored = !isProduction()
      values.pardotHandlerID = 'eloqua' // same eloqua endpoint for all forms
      values.cxxkie = document.cookie
      values.UTMParameters = window.sessionStorage.getItem('trial-utm')

      const accountRegistrationResult = yield call(
        create,
        accountEndpoint,
        values
      )
      const { orgslug } = accountRegistrationResult

      yield put(
        updateOrg({
          data: accountRegistrationResult,
        })
      )
      yield put(
        updateUserData({
          orgslug,
          email: values.email,
          username: values.username,
          portalUrl: accountRegistrationResult.returnTo,
        })
      )
      yield put(getConfigJson())
      yield put(getMeta({ orgslug }))

      yield call(action.payload.resolve)
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status === 400 && err.responseText
          ? JSON.parse(err.responseText)
          : null
      const errorData =
        data.errors &&
        data.errors.reduce((acc, cur) => {
          acc[cur.path.replace('obj.', '')] = cur.errors[0]
          return acc
        }, {})

      if (errorData) {
        yield call(action.payload.reject, new SubmissionError(errorData))
      }

      yield put(
        errorOrg({
          error: true,
          data: data,
        })
      )
    }
  }
}

export const Test = {
  _postOrg,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchPostOrg(api, error) {
  yield takeEvery(ORG_POST, _postOrg(api, error))
}
